import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import mapPrice from './mapPrice';
import Price from './Price';

export interface Result {
	items: { [key: string]: Price[] };
}

export default async function findPrices(client: ApiClient, userId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/datasource-computed-prices');
	const request = await client.fetch(url.expand({ userId }));
	const response = await request.json();

	const items: { [key: string]: Price[] } = {};
	Object.keys(response.items).forEach((key) => (items[key] = response.items[key].map(mapPrice)));
	return { items };
}
